import React from "react";
import { getCurrentLanguage, getLanguages } from '../../assets/js/functions';

const Head = () => {
  return  <ul className="is-flex gap-3 is-size-5 link-dn ml-auto">
    <li>
      <a
        title="Versión en español"
        hrefLang="es-ES"
        lang="es-ES"
        href="/maestros/es/"
      >
        {getCurrentLanguage() === 'es'?
        <span className="has-text-weight-bold">ES</span>
        :
        <>ES</>
        }
      </a>
    </li>
    <li>
      <a
        title="Euskarazko bertsioa"
        hrefLang="eu-ES"
        lang="eu-ES"
        href="/maestros/eu/"
      >
        {getCurrentLanguage() === 'eu'?
        <span className="has-text-weight-bold">EU</span>
        :
        <>EU</>
        }
      </a>
    </li>
  </ul>;
};

export default Head;
